/* Hook encargado de hacer la consulta a la base y 
traer la liquidación (settlement)

Autor: Benjamín León
Fecha: 2024-11-09
*/
import { useState } from 'react'

import { fechaIsoToYYYY_MM_DD } from '../utils/utils.ts'
import { customFetch } from '../utils/customFetch.ts'
import Purchase from '../interfaces/Purchase.ts'

import { makeUrlPurchase, makeUrlPurchaseVehicle } from './connectionData.tsx'

const usePurchaseFetcher = () => {
  const [errorPurchase, setErrorPurchase] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  const fetchPurchase = async (id: string) => {
    setLoading(true)

    try {
      const data = await fetchDatabase(id)
      setErrorPurchase(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      const myErr = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorPurchase(myErr)

      return null
    } finally {
      setLoading(false)
    }
  }
  const fetchDatabase = async (id: string): Promise<Purchase> => {
    const apiUrl = makeUrlPurchase(id)

    // Fetching documents from the collection and converting them into an array
    const purchase = await customFetch<Purchase>(apiUrl)

    if (Array.isArray(purchase.notes)) {
      const notes = (purchase.notes ?? []).join('\n')
      purchase.notes = notes
    }
    purchase.date = fechaIsoToYYYY_MM_DD(purchase.date)

    //reservation.date = formatDateToYYYY_MM_DD(new Date(reservation.date))
    return purchase
  }
  const fetchPurchaseVehicle = async (vehicleId: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlPurchaseVehicle(vehicleId)
      const data = await customFetch<Purchase>(apiUrl)
      setErrorPurchase(null)

      return data
    } catch (err) {
      // Assert the error as an instance of Error
      const myErr = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorPurchase(myErr)

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorPurchase, loading, fetchPurchase, fetchPurchaseVehicle }
}
export default usePurchaseFetcher
